export const TAX_CONSTANTS = {
  NEW_TAX_STATE_REQUEST: 'NEW_TAX_STATE_REQUEST',
  NEW_TAX_STATE_SUCCESS: 'NEW_TAX_STATE_SUCCESS',
  NEW_TAX_STATE_FAIL: 'NEW_TAX_STATE_FAIL',

  GET_ALL_STATES_REQUEST: 'GET_ALL_STATES_REQUEST',
  GET_ALL_STATES_SUCCESS: 'GET_ALL_STATES_SUCCESS',
  GET_ALL_STATES_FAIL: 'GET_ALL_STATES_FAIL',

  UPDATE_STATE_REQUEST: 'UPDATE_STATE_REQUEST',
  UPDATE_STATE_SUCCESS: 'UPDATE_STATE_SUCCESS',
  UPDATE_STATE_FAIL: 'UPDATE_STATE_FAIL',

  NEW_TAX_MODE_REQUEST: 'NEW_TAX_MODE_REQUEST',
  NEW_TAX_MODE_SUCCESS: 'NEW_TAX_MODE_SUCCESS',
  NEW_TAX_MODE_FAIL: 'NEW_TAX_MODE_FAIL',

  NEW_TAX_PRICE_REQUEST: 'NEW_TAX_PRICE_REQUEST',
  NEW_TAX_PRICE_SUCCESS: 'NEW_TAX_PRICE_SUCCESS',
  NEW_TAX_PRICE_FAIL: 'NEW_TAX_PRICE_FAIL',

  CREATE_TAX_REQUEST: 'CREATE_TAX_REQUEST',
  CREATE_TAX_SUCCESS: 'CREATE_TAX_SUCCESS',
  CREATE_TAX_FAIL: 'CREATE_TAX_FAIL',

  UPDATE_TAX_REQUEST: 'UPDATE_TAX_REQUEST',
  UPDATE_TAX_SUCCESS: 'UPDATE_TAX_SUCCESS',
  UPDATE_TAX_FAIL: 'UPDATE_TAX_FAIL',
  UPDATE_TAX_RESET: 'UPDATE_TAX_RESET',

  GET_ALL_TAXES_REQUEST: 'GET_ALL_TAXES_REQUEST',
  GET_ALL_TAXES_SUCCESS: 'GET_ALL_TAXES_SUCCESS',
  GET_ALL_TAXES_FAIL: 'GET_ALL_TAXES_FAIL',
  GET_ALL_TAXES_RESET: 'GET_ALL_TAXES_RESET',

  UPLOAD_TAX_REQUEST: 'UPLOAD_TAX_REQUEST',
  UPLOAD_TAX_SUCCESS: 'UPLOAD_TAX_SUCCESS',
  UPLOAD_TAX_FAIL: 'UPLOAD_TAX_FAIL',
  UPLOAD_TAX_RESET:'UPLOAD_TAX_RESET',

  CLEAR_ERRORS: 'CLEAR_ERRORS',
}
